module.exports = __webpack_public_path__ + "img/flechasDirecciones.fee375bd.svg";